var render = function render(){var _vm=this,_c=_vm._self._c;return _c('scars-template',{attrs:{"acne-scars":_vm.acneScars,"acne-scars-ai-selected":_vm.acneScarsAiSelected,"face-scars-appearance":_vm.faceScarsAppearance,"face-scars-appearance-visible":_vm.faceScarsAppearanceVisible,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }